var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eMDNCwnzWx51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 185.001 185.001",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: 185.001,
    height: 185.001,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eMDNCwnzWx52-fill",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eMDNCwnzWx52-fill-0",
    offset: "0%",
    stopColor: "rgb(94,40,202)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eMDNCwnzWx52-fill-1",
    offset: "42.1%",
    stopColor: "rgb(109,74,182)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eMDNCwnzWx52-fill-2",
    offset: "45.5%",
    stopColor: "rgb(113,77,175)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eMDNCwnzWx52-fill-3",
    offset: "54.2%",
    stopColor: "rgb(118,86,184)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eMDNCwnzWx52-fill-4",
    offset: "61.6%",
    stopColor: "rgb(132,107,181)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eMDNCwnzWx52-fill-5",
    offset: "74.9%",
    stopColor: "rgb(200,184,219)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eMDNCwnzWx52-fill-6",
    offset: "95.6%",
    stopColor: "rgb(204,185,229)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eMDNCwnzWx52",
    d: "M9570.5,3350C9552.067496,3350.028646,9534.050634,3344.524549,9518.781,3334.2C9503.908893,3324.15997,9492.267707,3310.022284,9485.268,3293.5C9473.078992,3264.700159,9476.288149,3231.688891,9493.796,3205.776C9503.835601,3190.903503,9517.973416,3179.262211,9534.496,3172.263C9563.295811,3160.075212,9596.306337,3163.28471,9622.219,3180.792C9637.091594,3190.831756,9648.733171,3204.969496,9655.733,3221.492C9667.922008,3250.291841,9664.712851,3283.303109,9647.205,3309.216C9637.165056,3324.088185,9623.027344,3335.729392,9606.505,3342.729C9595.11482,3347.550588,9582.868644,3350.023632,9570.5,3350ZM9570.5,3177C9526.041078,3177,9490,3213.041078,9490,3257.5C9490,3301.958922,9526.041078,3338,9570.5,3338C9614.958922,3338,9651,3301.958922,9651,3257.5C9650.949301,3213.062095,9614.937905,3177.050699,9570.5,3177Z",
    transform: "matrix(1 0 0 1 -9478 -3165)",
    fill: "url(#eMDNCwnzWx52-fill)",
    stroke: "none",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.6f3ea7c0cfd7ac34713d06d009998087.svg";
export { ForwardRef as ReactComponent };